import type { CustomerJobMetadataPolicy } from '~/lib/customer-job-metadata';
import { McmPhotoType } from '~/tenants/mcm/performable/photo/McmPhotoConfig';
import { McmDroneType } from '~/tenants/mcm/performable/drone/McmDroneConfig';
import { TwtEditingType } from '~/tenants/twt/performable/editing/TwtEditingConfig';

/**
 * MCM: which fields of each service a customer's post may set (lib/customer-
 * job-metadata.ts), by service id. Every field of every service's schema is
 * listed once, customer or office (customer-job-metadata.test.ts).
 */
export const MCM_CUSTOMER_JOB_METADATA: Record<string, CustomerJobMetadataPolicy> = {
  // McmPhotoForm: Reshoot and Economy are the office's.
  photo: {
    customer: ['type', 'twilight', 'extra_photos'],
    office: [],
    officeValues: { type: [McmPhotoType.RESHOOT, McmPhotoType.ECONOMY] },
  },
  virtual: { customer: ['photos'], office: [] },
  // McmDroneForm hides the two video-only types from customers.
  drone: {
    customer: ['type', 'twilight'],
    office: [],
    officeValues: { type: [McmDroneType.VIDEO_LIMITED, McmDroneType.VIDEO_FULL] },
  },
  video: { customer: ['type', 'agent', 'orientation', 'extra', 'social_edit', 'day_to_night'], office: [] },
  floorplan: { customer: [], office: [] },
  zillow: { customer: [], office: [] },
  matterport: { customer: ['exterior', 'floorplan'], office: [] },
  slideshow: { customer: ['orientation'], office: [] },
  // Request Edits is Twist's form (TwtEditingAction): no Blue Sky or Sunset Sky.
  editing: {
    customer: ['images'],
    office: [],
    officeValues: { 'images[].type': [TwtEditingType.BLUE_SKY, TwtEditingType.SUNSET_SKY] },
  },
  sold: { customer: [], office: [] },
  // the office's own service (hidden from every customer): every field is the office's.
  custom: { customer: [], office: ['description', 'onsite', 'revenue', 'taxable', 'package', 'slideshow'] },
  staging: { customer: ['photos'], office: [] },
  quick: { customer: [], office: [] },
};
